import './LiksChatMessageImageMetaBadges.css';

export type LiksChatMessageImageMetaBadgesProps = {
  imageFormat?: string | null;
  imageAspectRatio?: string | null;
  variant?: 'inline' | 'overlay';
};

export function LiksChatMessageImageMetaBadges({
  imageFormat,
  imageAspectRatio,
  variant = 'inline',
}: LiksChatMessageImageMetaBadgesProps) {
  const formatBadge = imageFormat?.trim() || null;
  const aspectRatioBadge = imageAspectRatio?.trim() || null;

  if (!formatBadge && !aspectRatioBadge) {
    return null;
  }

  return (
    <div
      className={[
        'liks-chat-message__image-meta-badges',
        variant === 'overlay' &&
          'liks-chat-message__image-meta-badges--overlay',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {formatBadge && (
        <span className="liks-chat-message__image-meta-badge liks-chat-message__image-meta-badge--format">
          {formatBadge}
        </span>
      )}
      {aspectRatioBadge && (
        <span className="liks-chat-message__image-meta-badge liks-chat-message__image-meta-badge--aspect-ratio">
          {aspectRatioBadge}
        </span>
      )}
    </div>
  );
}
